function getUrlHostname(url) {
  let a = document.createElement('a');
  a.href = url;
  return a.hostname;
}

function handleComboJs(result) {
  let re = /<script[^><]+src=['"]([^"']+)["']/gm;
  let src,
    newArr = [];
  while ((src = re.exec(result)) != null) {
    let match = src[1];
    if (getUrlHostname(match) == 'g.alicdn.com') {
      match = match.replace(/ali-mod\/\?\?|\?\?\ali-mod\//gm, 'ali-mod/');
      let scriptArr = match.split(',');
      for (let i = 0, len = scriptArr.length; i < len; i++) {
        let item = scriptArr[i];
        if (item.indexOf('ali-mod/') == -1 && item.indexOf('g.alicdn.com/') == -1) {
          newArr.push('<script src="//g.alicdn.com/ali-mod/' + item + '"></script>');
        } else {
          newArr.push('<script src="' + item + '"></script>');
        }
      }
    }
  }

  return newArr.join('\n');
}
function handleComboCss(result) {
  let re = /<link[^><]+href=['"]([^"']+)["']/gm;
  let src;
  let newArr = [];
  while ((src = re.exec(result)) != null) {
    let match = src[1];
    if (getUrlHostname(match) == 'g.alicdn.com') {
      match = match.replace(/ali-mod\/\?\?|\?\?\ali-mod\//gm, 'ali-mod/');
      let arr = match.split(',');
      for (let i = 0, len = arr.length; i < len; i++) {
        let item = arr[i];
        if (item.indexOf('ali-mod/') == -1 && item.indexOf('g.alicdn.com/') == -1) {
          newArr.push('<link rel="stylesheet" type="text/css" href="//g.alicdn.com/ali-mod/' + item + '"/>');
        } else {
          newArr.push('<link rel="stylesheet" type="text/css" href="' + item + '"/>');
        }
      }
    }
  }

  return newArr.join('\n');
}
function handleComboCssAndJs(result) {
  let resourceHtml = [],
    resourceScript = [];
  resourceHtml.push(handleComboCss(result));
  resourceScript.push(handleComboJs(result));
  result = result.replace(/<link([^<]+)\/?>/gi, '').replace(/<script([^><]+)src=.+<\/script>/gi, '');
  return resourceHtml.join('') + result + resourceScript.join('');
}

function init() {
  try {
    jQuery('[aliyun-lego-data]').each(function(index, item) {
      let $item = jQuery(item);
      if (!$item.attr('aliyun-lego-tip')) {
        $item.attr('aliyun-lego-tip', true);
        let url = $item.attr('aliyun-lego-data');
        if (getUrlHostname(url) !== 'www.aliyun.com') {
          return;
        }
        jQuery.getJSON(url + '?callback=?', function(data) {
          data = handleComboCssAndJs(data);
          //content中的js，如果用 ??aliyun 这种方式，在jquery插入到dom中时，判断有?,则会增加时间戳&_=xxx,导致报错，所以要清除掉
          $item.html(data);
        });
      }
    });
  } catch (e) {
    console.log(e);
  }
}
function lego(distUrl) {
  return new Promise((resolve, reject) => {
    // 超时处理
    setTimeout(() => {
      reject('Timeout 5000ms');
    }, 5000);
    if (getUrlHostname(distUrl) !== 'www.aliyun.com') {
      return;
    }
    jQuery.getJSON(distUrl + '?callback=?', function(data) {
      let dom = handleComboCssAndJs(data);
      //content中的js，如果用 ??aliyun 这种方式，在jquery插入到dom中时，判断有?,则会增加时间戳&_=xxx,导致报错，所以要清除掉
      resolve(dom);
    });
  });
}

//手动初始化
window.Aliyun_Lego_System_Manual_Init = init;
//自动初始化
jQuery(function() {
  try {
    init();
  } catch (e) {
    console.log(e);
  }
});

export default lego;



// WEBPACK FOOTER //
// ./src/components/lego.js